import { axiosClient } from '@/api/axios.ts'
import type { CreateUserPayload, InviteUserPayload, UpdateUserPayload } from '@/api/users/types.ts'
export const authMe = () => {
  return axiosClient.get('/auth/me')
}

export const getUsersList = (params?: { search?: string }) => {
  return axiosClient.get('/users', { params })
}

export const createUser = (payload: CreateUserPayload) => {
  return axiosClient.post('/users', payload)
}

export const updateUser = (payload: { id: string; updatedUser: UpdateUserPayload }) => {
  return axiosClient.patch(`/users/${payload.id}`, payload.updatedUser)
}

export const resetUserCredentials = (id: string) => {
  return axiosClient.post(`/users/reset-credentials/${id}`)
}

export const activateUser = (id: string) => {
  return axiosClient.post(`/users/${id}/activate`)
}

export const deactivateUser = (id: string) => {
  return axiosClient.post(`/users/${id}/deactivate`)
}

export const deleteUser = (id: string) => {
  return axiosClient.delete(`/users/${id}`)
}

export const inviteUser = (payload: InviteUserPayload) => {
  return axiosClient.post('users/invite', payload)
}
